import type { Lead } from "@/mocks/leadsData";
import { sourceBadgeColors, stageBadgeColors, priorityBadgeColors, priorityDotColors } from "@/mocks/leadsData";

type Props = {
  lead: Lead;
  onEdit: () => void;
  onAddActivity: () => void;
};

export function LeadHeaderCard({ lead, onEdit, onAddActivity }: Props) {
  const initials = lead.name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase();

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 md:p-6">
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
        <div className="flex items-start gap-4">
          <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-indigo-100 flex items-center justify-center text-2xl font-bold text-indigo-700 flex-shrink-0">
            {initials}
          </div>
          <div className="min-w-0">
            <h1 className="text-2xl font-bold text-gray-900 truncate">{lead.name}</h1>
            <p className="text-base text-gray-500 mt-0.5">{lead.company}</p>
            <div className="flex flex-wrap items-center gap-2 mt-3">
              <span className={`px-2.5 py-1 rounded-full text-[11px] font-semibold ${stageBadgeColors[lead.stage]}`}>
                {lead.stage}
              </span>
              <span className={`px-2.5 py-1 rounded-full text-[11px] font-semibold ${sourceBadgeColors[lead.source]}`}>
                {lead.source}
              </span>
              <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold ${priorityBadgeColors[lead.priority]}`}>
                <span className={`w-1.5 h-1.5 rounded-full ${priorityDotColors[lead.priority]}`} />
                {lead.priority}
              </span>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2.5 flex-shrink-0">
          <button
            onClick={onEdit}
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold transition-all duration-200 whitespace-nowrap"
          >
            <i className="ri-edit-line" /> Edit Lead
          </button>
          <button
            onClick={onAddActivity}
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg border border-indigo-600 text-indigo-600 text-sm font-semibold hover:bg-indigo-50 transition-all duration-200 whitespace-nowrap"
          >
            <i className="ri-add-line" /> Add Activity
          </button>
        </div>
      </div>
    </div>
  );
}